import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import instance from '@src/api/axiosInstance';

interface EditSchedulePayload {
  schedule_id: number;
  frequency: 'hourly' | 'daily' | 'weekly';
  time: string;
  day: string | null;
  next_run: string;
  subscribers: string[];
  is_internal?: boolean;
}

const editSchedule = async (data: EditSchedulePayload): Promise<any> => {
  const { schedule_id, ...body } = data;
  const response = await instance.put(`/nexa/schedule/edit/${schedule_id}`, body);
  return response.data;
};

export const useEditSchedule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editSchedule,
    onSuccess: (data) => {
      message.success(data?.message || 'Schedule updated successfully');
      queryClient.invalidateQueries(['nexa-schedule-list']);
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message || 'Failed to update schedule');
    },
  });
};
